"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcCompanyFormContracts = class UcCompanyFormContracts extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    company;
    onCompany(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("company");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_contract', { parameters: { filter: 'counterparty_id eq "' + this.company.id + '"' } })
            .then(resp => _.orderBy(resp.data, ['valid_from', 'valid_to'], ['desc', 'desc']));
    }
    ux;
    b_1468474219929533_displayCounterparty;
    dataMembers = ['items', 'ux', 'b_1468474219929533_displayCounterparty'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
                b_1468474219929533_displayCounterparty: false,
            },
        };
    }
    async evh_3343864469950044_close_6921_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_3343864469950044_showModal_6920_getActionArgs($event) {
        return {
            name: "CreateContract",
            props: {
                clientId: this.company.id,
            },
        };
    }
    async evh_3343864469950044_clickPreventStop(event, scope) {
        return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_3343864469950044_reloadComponentData_6922 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_3343864469950044_close_6921 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_reloadComponentData_6922,
            event: "close",
            when: this.evh_3343864469950044_close_6921_getWhen,
            displayName: "reloadComponentData",
        });
        const act_3343864469950044_showModal_6920 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_6920_getActionArgs,
            events: [evh_3343864469950044_close_6921],
        });
        const evh_3343864469950044_clickPreventStop_6919 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_6920,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3343864469950044_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_clickPreventStop_6919],
        });
        return {
            act_3343864469950044_reloadComponentData_6922,
            evh_3343864469950044_close_6921,
            act_3343864469950044_showModal_6920,
            evh_3343864469950044_clickPreventStop_6919,
            evh_3343864469950044_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcCompanyFormContracts.prototype, "company", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('company'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcCompanyFormContracts.prototype, "onCompany", null);
UcCompanyFormContracts = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcCompanyFormContracts);
exports.default = UcCompanyFormContracts;
vue_property_decorator_1.Vue.component("UcCompanyFormContracts", UcCompanyFormContracts);
